import { sendSMS as sendRingCentralSMS, formatPhoneNumber as formatRingCentralPhone } from '../services/ringcentralService';

/**
 * Send SMS via RingCentral (replaces GoHighLevel)
 */
export async function sendSMS(params: {
  phone: string;
  message: string;
  from?: string;
}): Promise<{ success: boolean; error?: string }> {
  try {
    const formattedPhone = formatPhoneNumber(params.phone);
    
    await sendRingCentralSMS({
      to: [formattedPhone],
      from: params.from,
      text: params.message,
    });

    return { success: true };
  } catch (error: any) {
    console.error('Error sending SMS via RingCentral:', error);
    return { 
      success: false, 
      error: error.message || 'Failed to send SMS' 
    };
  }
}

/**
 * Format phone number to E.164 format
 */
export function formatPhoneNumber(phone: string): string {
  return formatRingCentralPhone(phone);
}

/**
 * Send bulk SMS to multiple recipients
 */
export async function sendBulkSMS(params: {
  phones: string[];
  message: string;
  from?: string;
}): Promise<{ 
  success: boolean; 
  sent: number; 
  failed: number;
  errors: string[];
}> {
  const results = {
    success: true,
    sent: 0,
    failed: 0,
    errors: [] as string[],
  };

  for (const phone of params.phones) {
    const result = await sendSMS({
      phone,
      message: params.message,
      from: params.from,
    });

    if (result.success) {
      results.sent++;
    } else {
      results.failed++;
      results.errors.push(`${phone}: ${result.error}`);
    }
  }

  results.success = results.failed === 0;
  return results;
}
